import { OverlayPanelPassThroughOptions } from 'primereact/overlaypanel';
import { classNames } from 'primereact/utils';

export const PTOverlayPanel: OverlayPanelPassThroughOptions = {
  root: {
    className: classNames(
      'bg-white border-0 rounded-lg shadow-lg',
      'z-40 transform origin-center',
      'absolute mt-3',
    ),
  },
  closeButton: {
    className:
      'flex items-center justify-center overflow-hidden absolute top-0 right-0 w-6 h-6',
  },
  content: {
    className: 'flex items-center w-full p-4',
  },
  transition: {
    addEndListener: () => {},
    classNames: {
      enter: 'opacity-0 scale-75',
      enterActive:
        'opacity-100 !scale-100 transition-transform transition-opacity duration-150 ease-in',
      exit: 'opacity-100',
      exitActive: '!opacity-0 transition-opacity duration-150 ease-linear',
    },
  },
};
